import styled from 'styled-components';

import { assetItemBG } from '@themes';

export const DnDAssetsList = styled.div`
  padding: 1rem;
  background-color: ${assetItemBG};
  width: 100%;
`;

export const NewAssetBtn = styled.div`
  text-align: center;
`;
